import { render, staticRenderFns } from "./yzgyzyjsxy.vue?vue&type=template&id=2fbe33fe&scoped=true&"
import script from "./yzgyzyjsxy.vue?vue&type=script&lang=js&"
export * from "./yzgyzyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./yzgyzyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./yzgyzyjsxy.vue?vue&type=style&index=1&id=2fbe33fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbe33fe",
  null
  
)

export default component.exports